<template>
  <div class="analystics-topbar-wrap">
    <v-row class="analytics-top-bar">
      <v-col cols="6">
        <div class="analytics-title-wrap">
          <div class="analytics-back-btn">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  v-bind="attrs"
                  v-on="on"
                  text
                  @click="onClickBack()"
                >
                  <v-icon>las la-arrow-left</v-icon></v-btn>
              </template>
              <span>Go Back</span>
            </v-tooltip>
          </div>
          <div class="analytics-title" v-if="title">
            <v-select
              class="report-select"
              :items="items"
              hide-details
              flat
              dense
              v-model="analyticsType"
            ></v-select>
          </div>
          <!-- <div class="analytics-title" v-else>--</div> -->
        </div>
      </v-col>
      <v-col cols="6" class="pr-7 d-flex justify-end" :class="!checkPermission(['data_export']) ? 'disable-action' : ''">
        <div
          v-if="analyticsType !== 'Gender-wise engagement analysis' && downloadingFlag && analyticsType !== 'Group wise engagement metrics' && analyticsType !== 'Age group wise engagement analysis'"
          class="d-flex box-container px-3 mx-2"
          style="height: 2.4rem;"
        >
          <v-btn :loading="true" icon></v-btn>
          <div class="pl-1 d-flex align-center">downloading...</div>
        </div>
        <!-- <v-btn
          v-if="analyticsType !== 'Gender-wise engagement analysis' && !downloadingFlag && analyticsType !== 'Group wise engagement metrics' && analyticsType !== 'Age group wise engagement analysis'"
          class="box-container downloadReportBtn zoom-in mx-1"
          :disabled="!checkPermission(['data_export'])"
          @click="downloadReport()"
        >
          <v-icon small class="mr-2">las la-cloud-download-alt</v-icon>
          <span>Export report</span>
        </v-btn> -->
        <v-menu offset-y offset-overflow max-width="400" v-if="analyticsType !== 'Gender-wise engagement analysis' && !downloadingFlag && analyticsType !== 'Group wise engagement metrics' && analyticsType !== 'Age group wise engagement analysis'"
        :disabled="!checkPermission(['data_export'])">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="box-container zoom-in ml-1 mr-4"
            >
              <v-icon small class="mr-2">las la-cloud-download-alt</v-icon>
              <span>Export report</span>
            </v-btn>
          </template>
          <v-list three-line>
            <v-list-item @click="downloadReport('withFilterData')">
              <v-list-item-avatar>
                <i class="las la-filter"></i>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Currently filtered</v-list-item-title>
                <v-list-item-subtitle>
                  Export report of all data
                  that are currently shown in the
                  table on the page.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="downloadReport()">
              <v-list-item-avatar>
                <i class="las la-user-friends"></i>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>All data</v-list-item-title>
                <v-list-item-subtitle>
                  Export the list of all data
                  that are present in {{user.company_name}}.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <span class="abcd" style="position: absolute;
    bottom: 95%;
    margin-right: 5%;
    background: #65636394;
    color: white;
    padding: 3px 5px;
    border-radius: 5px;
    font-size: 80%;">You have not enough permission</span> -->
        <v-btn
          color="white"
          class="box-container zoom-in"
          @click.stop="toggleReportFilter"
        >
          <i class="las la-filter mr-1"></i>
          <span>Filter</span>
        </v-btn>
        <v-btn
          icon
          v-if="isFilterApplied"
          class="box-container zoom-in ml-2"
          @click="resetDashFilters"
        >
          <i class="las la-sync-alt"></i>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import AnalyticsMixin from './analytics-mixin.js';

export default {
  name: 'AnalyticsTopbar',

  mixins: [AnalyticsMixin],

  props: {
    title: {
      required: true,
      type: String
    },
    sortKey: {
      required: false,
      type: String
    },
    isFilterApplied: {
      required: true,
      type: Boolean
    }
  },

  data () {
    return {
      // isFilterApplied: false,
      withFilterData: false,
      downloadingFlag: false,
      items: [
        'Employee lifecycle',
        'Employee participation rate',
        'Chat response rate',
        'Gender-wise engagement analysis',
        'Custom report',
        'Group wise engagement metrics',
        'Age group wise engagement analysis'
      ],
      analyticsType: 'Employee lifecycle'
    };
  },

  mounted () {
    if (this.title) {
      this.analyticsType = this.title;
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      dashboardFilters: state => state.updateReportFilters
    })
  },
  watch: {
    analyticsType () {
      // console.log('analyticsType -> this.analyticsType', this.analyticsType);
      if (this.analyticsType === 'Employee lifecycle') {
        this.$router.push({ path: '/analytics/life-cycle' }).catch(() => {});
      }
      if (this.analyticsType === 'Employee participation rate') {
        this.$router.push({ path: '/analytics/participation-rate' }).catch(() => {});
      }
      if (this.analyticsType === 'Chat response rate') {
        this.$router.push({ path: '/analytics/response-rate' }).catch(() => {});
      }
      if (this.analyticsType === 'Gender-wise engagement analysis') {
        this.$router.push({ path: '/analytics/diversity-report' }).catch(() => {});
      }
      if (this.analyticsType === 'Custom report') {
        this.$router.push({ path: '/analytics/custom-report' }).catch(() => {});
      }
      if (this.analyticsType === 'Group wise engagement metrics') {
        this.$router.push({ path: '/analytics/group-metrics-report' }).catch(() => {});
      }
      if (this.analyticsType === 'Age group wise engagement analysis') {
        this.$router.push({ path: '/analytics/age-group-report' }).catch(() => {});
      }
    }
  },

  methods: {
    checkPermission (permission) {
      let flag = false;
      this.$lodash.each(this.user.permissions, (perm) => {
        this.$lodash.each(permission, (v) => {
          if (v === perm) {
            flag = true;
          }
        });
      });
      return flag;
    },
    onClickBack () {
      this.$router.push({ path: '/analytics' }).catch(() => {});
    },
    toggleReportFilter () {
      this.$emit('toggleReportFilter');
    },
    resetDashFilters () {
      this.$emit('resetDashFilters');
    },
    // downloadReport (type) {
    //   console.log('downloadReport -> type', type);
    //   http://localhost:8000/feedback_bot
    // },
    downloadReport (type) {
      if (type === 'withFilterData') {
        this.withFilterData = true;
      }
      console.log(this.dashboardFilters);
      const queryParams = {};
      if (this.dashboardFilters.high_potential_emp) {
        queryParams.user__profile__high_potential_emp = true;
      }
      if (this.dashboardFilters.initiated_date_end) {
        queryParams.segment_filter = this.dashboardFilters && this.dashboardFilters.segment_filter ? this.dashboardFilters.segment_filter : undefined;
      }
      if (this.dashboardFilters.initiated_date_start) {
        queryParams.initiated_date_start = this.dashboardFilters.initiated_date_start;
        queryParams.initiated_date_end = this.dashboardFilters.initiated_date_end;
      }
      if (this.dashboardFilters && this.dashboardFilters.filters) {
        this.$lodash.each(this.dashboardFilters.filters, (v, k) => {
          if (v.length > 0 && k !== 'session__stage__title') {
            queryParams[`user__profile__${k}__in`] = v.join();
          } else {
            queryParams.stage__title__in = v.join();
          }
        });
      }
      let url = `${process.env.VUE_APP_API_URL}reports/download_analytics_excel_report?report_type=employee_life_cycle&sort_key=session__user__user_profile__${this.sortKey}&fields=segment_points_analysis,engagement_score,segment_participation_stats,disengaged_employees_stats,segment_nps_breakdown,engagement_heatmap,drivers_analysis`;
      if (this.analyticsType === 'Chat response rate') {
        url = `${process.env.VUE_APP_API_URL}reports/download_analytics_excel_report?report_type=chat_response&sheets=chat_participation_stats,chat_participation_trends&sort_key=${this.sortKey}&fields=chat_participation_stats,chat_participation_trends`;
      }
      if (this.analyticsType === 'Employee participation rate') {
        url = `${process.env.VUE_APP_API_URL}reports/download_analytics_excel_report?report_type=employee_participation&sheets=user_participation_stats,user_participation_trends&sort_key=${this.sortKey}&fields=user_participation_stats,user_participation_trends`;
      }
      if (this.withFilterData) {
        axios.get(url, {
          params: queryParams
        }).then((response) => {
          // console.log('response', response);
          this.withFilterData = false;
          if (response && response.data && response.data.success) {
            if (response.data.report_url) {
              this.downloadingFlag = false;
              this.$forceUpdate();
              setTimeout(() => {
                window.open(response.data.report_url);
              }, 100);
            } else {
              this.downloadingFlag = false;
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: 'Unable to generate report, Please try again later!'
              });
            }
            this.reportDialog = false;
          } else {
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
            this.reportDialog = false;
          }
          this.downloadingFlag = false;
        }).catch((err) => {
          if (err.response.status === 429) {
            // this.loading = false;
            // this.open = false;
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            // this.loading = false;
            // this.open = false;
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
          }
        });
      } else {
        axios.post(url).then((response) => {
          // console.log('response', response);
          if (response && response.data && response.data.success) {
            if (response.data.report_url) {
              this.downloadingFlag = false;
              this.$forceUpdate();
              setTimeout(() => {
                window.open(response.data.report_url);
              }, 100);
            } else {
              this.downloadingFlag = false;
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: 'Unable to generate report, Please try again later!'
              });
            }
            this.reportDialog = false;
          } else {
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
            this.reportDialog = false;
          }
          this.downloadingFlag = false;
        }).catch((err) => {
          if (err.response.status === 429) {
            // this.loading = false;
            // this.open = false;
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            // this.loading = false;
            // this.open = false;
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.analystics-topbar-wrap {
  .analytics-top-bar {
    background: #050550;
    // background: #584475;
    background-image: -webkit-gradient(linear,right top, left top,from(transparent),to(rgba(51,148,255,0.18)));
    .analytics-title {
      color: var(--bg);
      display: flex;
      align-items: center;
      font-size: var(--stats-size-1);
    }
    .analytics-title-wrap {
      display: flex;
    }
  }
}
</style>

<style lang="scss">
.disable-action {
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: var(--bg) !important;
  }
}
.abcd {
    display: none;
  }
.downloadReportBtn:hover {
  .abcd {
    display: block;
  }
}
// .v-select__selection v-select__selection--comma
.analytics-top-bar {
  .report-select {
    .v-select__selection {
      color: var(--bg) !important;
    }
    .v-input__slot {
      .v-input__icon--append {
        .v-icon {
          color: var(--bg) !important;
        }
      }
      &:before {
        border-color: var(--bg) !important;
      }
    }
  }
}
</style>
